import React, { useState } from 'react';
import classNames from 'classnames';
import './LeadPopupConfirmationForm.pcss';
import TextInput from '../../../../../../common/components/TextInput';
import { OptinSettings, PromoterModel } from '@mm/state/model/PromoterModel';
import { PreviewBox } from '../common/PreviewBox/PreviewBox';
import { LeadPopupConfirmationPreview } from './LeadPopupConfirmationPreview/LeadPopupConfirmationPreview';

type Props = {
  className?: string;
  promoter: PromoterModel;
  onUpdate: (promoter: PromoterModel) => void;
};

const FIELDS = {
  description: 'confirmationDescription',
  title: 'confirmationTitle',
  button: 'confirmationButtonText',
};

export const LeadPopupConfirmationForm = ({
  className,
  promoter,
  onUpdate,
}: Props) => {
  const { optinSettings } = promoter;
  const { confirmationTitle, confirmationDescription, confirmationButtonText } =
    optinSettings || {};

  const [textFields, setTextFields] = useState({
    confirmationTitle,
    confirmationDescription,
    confirmationButtonText,
  });

  const updateSettings = (up: OptinSettings) => {
    const updatedSettings = { ...(optinSettings || {}), ...up };
    onUpdate({ ...promoter, optinSettings: updatedSettings });
  };

  const onFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setTextFields({ ...textFields, [id]: value });
  };

  const onFieldBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    updateSettings({ [id]: value });
  };

  return (
    <div
      className={classNames(
        className,
        'lead-popup-confirmation-form__container',
      )}
    >
      <div className="lead-popup-confirmation-form__config">
        <div className="lead-popup-confirmation-form__input-wrapper">
          <span className="lead-popup-confirmation-form__config-item-name">
            Title
          </span>
          <TextInput
            className="lead-popup-confirmation-form__input"
            id={FIELDS.title}
            value={textFields.confirmationTitle}
            onChange={onFieldChange}
            onBlur={onFieldBlur}
          />
        </div>

        <div className="lead-popup-confirmation-form__input-wrapper">
          <span className="lead-popup-confirmation-form__config-item-name">
            Description
          </span>
          <TextInput
            className="lead-popup-confirmation-form__input"
            id={FIELDS.description}
            value={textFields.confirmationDescription}
            onChange={onFieldChange}
            onBlur={onFieldBlur}
          />
        </div>

        <div className="lead-popup-confirmation-form__input-wrapper">
          <span className="lead-popup-confirmation-form__config-item-name">
            Button
          </span>
          <TextInput
            className="lead-popup-confirmation-form__input"
            id={FIELDS.button}
            value={textFields.confirmationButtonText}
            onChange={onFieldChange}
            onBlur={onFieldBlur}
          />
        </div>
      </div>

      <div className="lead-popup-confirmation-form__preview">
        <PreviewBox>
          {({ isMobile }) => (
            <LeadPopupConfirmationPreview
              isMobile={isMobile}
              title={textFields.confirmationTitle}
              description={textFields.confirmationDescription}
              buttonText={textFields.confirmationButtonText}
            />
          )}
        </PreviewBox>
      </div>
    </div>
  );
};
